import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ProblemSection from "@/components/ProblemSection";
import Features from "@/components/Features";
import TopicsSection from "@/components/TopicsSection";
import BeamySection from "@/components/BeamySection";
import AppPreview from "@/components/AppPreview";
import DifferentiatorSection from "@/components/DifferentiatorSection";
import AboutSection from "@/components/AboutSection";
import WaitlistForm from "@/components/WaitlistForm";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import SEO from "@/components/SEO";

const FAQ_JSONLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    { "@type": "Question", name: "Was ist finbeam?", acceptedAnswer: { "@type": "Answer", text: "finbeam ist eine Finanzbildungs-App für die Schweiz mit interaktiven Modulen, Tools und einem AI-Coach namens beamy." } },
    { "@type": "Question", name: "Für wen ist finbeam?", acceptedAnswer: { "@type": "Answer", text: "finbeam richtet sich an junge Erwachsene in der Schweiz, die ihre Finanzen in den Griff bekommen wollen." } },
    { "@type": "Question", name: "Was kostet finbeam?", acceptedAnswer: { "@type": "Answer", text: "Der Einstieg in finbeam ist kostenlos. Melde dich für die Warteliste an, um frühen Zugang zu erhalten." } },
    { "@type": "Question", name: "Was ist beamy?", acceptedAnswer: { "@type": "Answer", text: "beamy ist der AI-Finanzcoach von finbeam. Er beantwortet Finanzfragen verständlich und im Schweizer Kontext." } },
    { "@type": "Question", name: "Wann ist finbeam verfügbar?", acceptedAnswer: { "@type": "Answer", text: "finbeam befindet sich aktuell in der Entwicklung. Trage dich auf der Warteliste ein, um früh informiert zu werden." } },
  ],
};

const Index = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen">
      <SEO
        title="finbeam - Finanzen. Einfach erklärt."
        description="Lerne Finanzen spielerisch und praxisnah. finbeam macht Finanzbildung zugänglich für alle - in deiner Sprache, in deinem Alltag."
        path="/"
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(FAQ_JSONLD)}</script>
      </Helmet>
      <Header />
      <main>
        <Hero />
        <ProblemSection />
        <div id="features"><Features /></div>
        <TopicsSection />
        <BeamySection />
        <div id="preview"><AppPreview /></div>
        <DifferentiatorSection />
        <AboutSection />
        <WaitlistForm />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Index;

